import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { fontStyles } from '../../../../app/assets/fonts';

/** Design tokens for consulta-first redesign (mockup palette, existing typefaces). */
export const brandTokens = {
  navy: '#012F47',
  navyDark: '#001F30',
  tonal: '#001E2E',
  surfaceLowest: '#0D0E10',
  surface: '#121415',
  surfaceContainer: '#1E2022',
  cyan: '#6BD3FD',
  cyanMuted: '#4CB5DB',
  blueAccent: '#239CC4',
  green: '#51DF94',
  greenDark: '#00B26C',
  onSurface: '#E2E2E4',
  onSurfaceVariant: '#C2C7CD',
  paper: '#FFFFFF',
  backgroundApp: '#F5F7F9',
  signatureGradient: 'linear-gradient(135deg, #6BD3FD 0%, #51DF94 100%)',
  signatureGradientBlue: 'linear-gradient(135deg, #A6CBE9 0%, #6BD3FD 100%)',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandTokens.navy,
      light: '#1A4B68',
      dark: brandTokens.navyDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: brandTokens.blueAccent,
      light: brandTokens.cyanMuted,
      dark: '#0B7A9E',
      contrastText: '#FFFFFF',
    },
    success: {
      main: brandTokens.green,
      dark: brandTokens.greenDark,
      contrastText: brandTokens.navy,
    },
    info: {
      main: brandTokens.cyan,
      dark: '#279EC7',
      contrastText: brandTokens.navy,
    },
    background: {
      default: brandTokens.backgroundApp,
      paper: brandTokens.paper,
    },
    text: {
      primary: brandTokens.navy,
      secondary: 'rgba(1, 47, 71, 0.72)',
    },
  },
  typography: {
    fontFamily: 'GT Haptik, Roboto, sans-serif',
    h1: {
      fontFamily: 'GT Haptik, Raleway, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'GT Haptik, Raleway, sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'GT Haptik, Raleway, sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 300,
    },
    button: {
      fontFamily: 'GT Haptik, Roboto, sans-serif',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        ${fontStyles}
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        body {
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
        #root {
          min-height: 100vh;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          width: '100%',
          margin: 0,
          boxShadow: 'none',
        },
      },
    },
  },
});

export const ThemeConfig = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default theme;
